import type { ReactNode } from 'react';

export const symbol_family_link: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m500-183 280-397-280-280-280 280 280 397Zm0-339ZM400-47q-48 0-87-28.5T256-152q-10-27-28.39-42.5Q209.23-210 186-210q-17 0-33.5 7.5T121-181q-4 4-8.8 6-4.8 2-11.2 2-12 0-21-9t-9-21.24q0-5.76 2-11.05 2-5.3 7-9.71 22-22 49.26-34 27.25-12 56.74-12 42 0 76.5 27t52.5 74q11 29 34.05 45.5Q372.1-107 400-107q19 0 35.5-7t27.5-19L172-545q-6.4-8.21-9.2-17.16-2.8-8.95-2.8-17.9 0-11.94 4.5-22.9Q169-613.93 178-623l280-280q8.05-8.13 19.02-12.57Q488-920 500-920t22.98 4.43Q533.95-911.13 542-903l280 280q9 9.05 13.5 19.99Q840-592.07 840-580q0 10-3 18.5t-8 16.5L516-103q-19 26-49.5 41T400-47Z"
		/>
	</svg>
);
